export function isValidCPF(document) {
  const cpf = document.replaceAll('.', '').replace('-', '')
  var numeros, digitos, soma, i, resultado, digitosIguais;
  digitosIguais = 1;

  if (cpf.length < 11) {
    return false;
  }

  for (i = 0; i < cpf.length - 1; i++) {
    if (cpf.charAt(i) != cpf.charAt(i + 1)) {
      digitosIguais = 0;
      break;
    }
  }

  if (!digitosIguais) {
    numeros = cpf.substring(0, 9);
    digitos = cpf.substring(9);
    soma = 0;

    for (i = 10; i > 1; i--) {
      soma += numeros.charAt(10 - i) * i;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

    if (resultado != digitos.charAt(0)) {
      return false;
    }

    numeros = cpf.substring(0, 10);
    soma = 0;

    for (i = 11; i > 1; i--) {
      soma += numeros.charAt(11 - i) * i;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

    if (resultado != digitos.charAt(1)) {
      return false;
    }

    return true;
  } else {
    return false;
  }
}

export function isValidCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\w]/g, "");

  if (cnpj == "") return false;
  if (cnpj.length != 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  // Valida DVs
  const body = cnpj.substring(0, 12);
  const dv1 = parseInt(cnpj.charAt(12), 10);
  const dv2 = parseInt(cnpj.charAt(13), 10);

  if (isNaN(dv1) || isNaN(dv2)) return false;

  // primeiro DV
  const calculatedDV1 = calculateDV(body);
  if (calculatedDV1 === -1) return false;
  if (calculatedDV1 !== dv1) return false;

  // segundo DV
  const bodyWithDV1 = body + calculatedDV1.toString();
  const calculatedDV2 = calculateDV(bodyWithDV1);
  if (calculatedDV2 === -1) return false;
  if (calculatedDV2 !== dv2) return false;

  return true;
}

function getDVValue(char) {
  const charCode = char.toUpperCase().charCodeAt(0);
  if (charCode >= 48 && charCode <= 57) {
    return charCode - 48;
  }
  if (charCode >= 65 && charCode <= 90) {
    return charCode + 17 - 65;
  }
  return -1;
}

function calculateDV(cnpjPartial) {
  const length = cnpjPartial.length;
  let sum = 0;
  let weight = 2;
  const initialWeight = 2;
  const maxWeight = 9;
  const restartWeightIndex = 8;

  for (let i = length - 1; i >= 0; i--) {
    const char = cnpjPartial[i];
    const value = getDVValue(char);

    if (value === -1) return -1;

    sum += value * weight;

    if ((length - i) % restartWeightIndex === 0) {
      weight = initialWeight;
    } else {
      weight++;
      if (weight > maxWeight) {
        weight = initialWeight;
      }
    }
  }

  const remainder = sum % 11;

  if (remainder === 0 || remainder === 1) {
    return 0;
  } else {
    return 11 - remainder;
  }
}